import { render } from "./ListItemCliente.vue?vue&type=template&id=05f5aa3e&scoped=true"
import script from "./ListItemCliente.vue?vue&type=script&lang=js"
export * from "./ListItemCliente.vue?vue&type=script&lang=js"

import "./ListItemCliente.vue?vue&type=style&index=0&id=05f5aa3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f5aa3e"]])

export default __exports__